import React from 'react'
import styled from '@emotion/styled'
import SvgClose from 'src/static/close_gray.svg'
import withProps from 'recompose/withProps'
import { isMobileOnly } from 'react-device-detect'
import { css } from '@emotion/core'
import { NavButton } from '../elements/styled-components'

const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  ${isMobileOnly &&
  css`
    backdrop-filter: blur(9px);
  `}
`

const DataContainer = withProps()(styled.div`
  position: relative;
  background: #ffffff;
  border: ${({ theme }: any) => {
    const color =
      !theme.agencyColor || theme.agencyColor === '' ? '#B202FF' : theme.agencyColor
    return `1px solid ${color}`
  }};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 549px;
  padding: 40px;

  ${isMobileOnly &&
  css`
    padding: 40px 36px;
    border: none;
    margin: 0 16px;
  `}
`)

const HeadContainer = styled.div`
  display: flex;
  width: 100;
`

const Title = styled.div`
  font-size: 32px;
  line-height: 34px;
  color: #1d0e3b;
  font-weight: 700;
  margin-bottom: 12px;
  flex: 1;

  ${isMobileOnly &&
  css`
    font-size: 26px !important;
    line-height: 32px !important;
    text-align: center;
  `}

  @media screen and (max-width: 2500px) {
    font-size: 28px;
    line-height: 30px;
  }
  @media screen and (max-width: 2000px) {
    font-size: 24px;
    line-height: 28px;
  }
  @media screen and (max-width: 1200px) {
    font-size: 20px;
    line-height: 24px;
  }
  @media screen and (max-width: 900px) {
    font-size: 16px;
    line-height: 18px;
  }
`

const AfterTitle = styled.div`
  font-size: 24px;
  line-height: 26px;
  color: #1d0e3b;
  font-weight: 400;
  margin: 4px 0 12px 0;
  flex: 1;

  ${isMobileOnly &&
  css`
    font-size: 14px !important;
    line-height: 24px !important;
    text-align: center;
  `}

  @media screen and (max-width: 2500px) {
    font-size: 20px;
    line-height: 22px;
  }
  @media screen and (max-width: 2000px) {
    font-size: 16px;
    line-height: 22px;
  }
  @media screen and (max-width: 1200px) {
    font-size: 12px;
    line-height: 16px;
  }
  @media screen and (max-width: 900px) {
    font-size: 8px;
    line-height: 10px;
  }
`

const BottomButton = withProps()(styled(NavButton)`
  width: fit-content;
  height: auto;
  border-radius: 60px;
  padding: 18px 46px;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  align-self: center;
  background: ${({ theme }: any) => {
    const color =
      !theme.agencyColor || theme.agencyColor === '' ? '#B202FF' : theme.agencyColor
    return color
  }};

  ${isMobileOnly &&
  css`
    margin-top: 28px;
  `}
`)

const CloseButton = styled.img`
  cursor: pointer;
  height: 18px;
  width: 18px;

  @media screen and (max-width: 2500px) {
    height: 16px;
    width: 16px;
  }
  @media screen and (max-width: 2000px) {
    height: 14px;
    width: 14px;
  }
  @media screen and (max-width: 1200px) {
    height: 12px;
    width: 12px;
  }
  @media screen and (max-width: 900px) {
    height: 10px;
    width: 10px;
  }

  ${isMobileOnly &&
  css`
    position: absolute;
    top: 21px;
    right: 21px;
    height: 15px !important;
    width: 15px !important;
  `}
`

export enum ErrorType {
  PermissionDenied,
  DeviceError,
}

interface IProps {
  onChange: () => void
  onClose: () => void
}

const ChangeQuestionPopup = ({ onClose, onChange }: IProps) => {
  return (
    <Container>
      <DataContainer>
        <HeadContainer>
          <Title>Want to try another question?</Title>
          <CloseButton onClick={onClose} src={SvgClose} />
        </HeadContainer>
        <AfterTitle>
          You have two additional alternative questions to choose from, and you can always
          revisit the current one. Please keep in mind that your response won’t be saved.
        </AfterTitle>
        <BottomButton hideIcon onClick={onChange}>
          GO
        </BottomButton>
      </DataContainer>
    </Container>
  )
}

export default ChangeQuestionPopup
